<!-- Información - Conductor asignado -->
<div class="col-md-12 driver pl-4 pr-2" *ngIf="driver && vehicle">
  <!-- Pricipal driver -->
  <div *ngIf="driver">
    <app-person-info [driver]="driver" [cargo]="cargo" [vehicle]="vehicle" [isOnlyDriver]="onlyDriver"
      [showAssignButton]="!utils.isDefined(secondDriver) && !utils.isSameCity(cargo)"
      (emitOpenDetailDriver)="checkOpenDetailAction($event, driver, 'driver')"
      (emitRefreshDriver)="refreshLoad.emit($event)">
    </app-person-info>
  </div>
  <!-- Second driver -->
  <div *ngIf="secondDriver">
    <app-person-info [driver]="secondDriver" [cargo]="cargo" [vehicle]="vehicle" [isOnlyDriver]="onlyDriver"
      [showActionsButtons]="true" (emitOpenDetailDriver)="checkOpenDetailAction($event, secondDriver, 'secondDriver')"
      (emitRefreshDriver)="refreshLoad.emit($event)">
    </app-person-info>
  </div>
  <!-- Vehicle info -->
  <div class="row m-0 p-0 py-4">
    <div class="offset-lg-2 col-lg-9">
      <div class="row mx-0 px-2 vehicle-info">
        <!-- licensePlate -->
        <div class="col-md-4 col-sm-6" *ngIf="vehicle && !onlyDriver">
          <div class="field__card">
            <label class="field__card--label m-0">
              Placa
            </label>
            <span class="field__card--value" [ngClass]="{'underline': showVehicleDetail}" (click)="openDetailVehicle()">
              {{vehicle.id ? vehicle.id : '-'}}
            </span>
          </div>
        </div>

        <!-- vehicleType -->
        <div class="col-md-4 col-sm-6" *ngIf="vehicle && vehicle.vehicleType && !onlyDriver">
          <div class="field__card">
            <label class="field__card--label m-0">Tipo de vehículo</label>
            <span class="field__card--value">
              {{vehicle.vehicleType ? (vehicle.vehicleType.name | capitalizeText) : '-'}}
            </span>
          </div>
        </div>

        <!-- State Vehicle -->
        <div class="col-md-4 col-sm-6" *ngIf="vehicle && !onlyDriver">
          <div class="field__card">
            <label class="field__card--label m-0">Estado Vehículo</label>
            <span class="field__card--value text__color"
              [ngClass]="{'color--error': !vehicle.state || (utils.isDefined(vehicle.state.active) && !vehicle.state.active), 'color--success': vehicle.state && vehicle.state.active}">
              {{vehiclesService.getVehicleState(vehicle)}}
            </span>
          </div>
        </div>
        <!--Vehicle inspection-->
        <div class="col-md-4 col-sm-6">
          <div class="field__card">
            <label class="field__card--label">
              Inspección preoperacional del vehículo
              <i class="fas fa-eye font-secondary-dark cursor-pointer" *ngIf="cargo?.vehicleInspection"
                (click)="openInspectionVehicle()"></i>
            </label>
            <span *ngIf="cargo?.vehicleInspection" class="field__card--value underline"
              [ngClass]="lastInspection?.approval ? 'color--success': 'color--error'" (click)="openInspectionVehicle()">
              {{utils.isDefined(lastInspection?.approval) ? (lastInspection?.approval ? 'Aprobado' : 'Rechazado') : 'Sin
              aprobar'}}
            </span>
            <span *ngIf="!cargo?.vehicleInspection" class="field__card--value underline color--error"
              (click)="createInspection()">
              Crear
            </span>
          </div>
        </div>

        <!-- trailerId -->
        <div class="col-md-4 col-sm-6" *ngIf="cargo && cargo.trailerId">
          <div class="field__card">
            <label class="field__card--label m-0">Trailer asociado</label>
            <span class="field__card--value">
              {{cargo.trailerId}}
            </span>
          </div>
        </div>

        <!--Container inspection-->
        <div class="col-md-4 col-sm-6" *ngIf="showContainerChecklist">
          <div class="field__card">
            <label class="field__card--label m-0">
              Inspección a las unidades de carga
              <i class="fas fa-eye font-secondary-dark" (click)="openContainerChecklist()"></i>
            </label>
            <span class="field__card--value underline"
              [ngClass]="lastContainerInspection?.approval ? 'color--success': 'color--error'"
              (click)="openContainerChecklist()">
              {{
              utils.isDefined(lastContainerInspection?.approval)
              ? lastContainerInspection?.approval
              ? 'Aprobado'
              : 'Rechazado'
              : !!lastContainerInspection
              ? 'Sin aprobar'
              : 'Crear'
              }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!--NEW DESING-->
<div class="main-container">
  <div class="container-content" *ngIf="!vehicle && !owner && !administrator">
    <div class="container-photo">
      <figure class="driver__picture driver__picture--loaded"
        *ngIf="driver?.profilePictureUrl && driver?.information?.name">
        <img [src]="driver?.profilePictureUrl" alt="">
      </figure>
      <figure class="driver__picture driver__picture--loaded"
        *ngIf="!driver?.profilePictureUrl || !driver?.information?.name">
        <img src="/assets/svg/icons/icon-profile.png" alt="">
      </figure>
      <div class="driver__score__column">
        <div class="text-center driver__score" *ngIf="driver?.teclogiScore && driver?.state && driver?.state.active">
          <img *ngFor="let star of scoreDriver" src="/assets/svg/icons/icon-star-purple.svg"
            [ngStyle]="{'filter':driver?.teclogiScore?.globalScore<=2&&'invert(32%) sepia(80%) saturate(7072%) hue-rotate(353deg) brightness(95%) contrast(133%)'}">
        </div>
      </div>
      <div>
        <div class="text-center">
          <!--PHOTO
            <div>
              <label for="upload-photo">
                <i class="fas fa-camera i-picture" for="upload-photo"></i>
              </label>
              <input type="file" name="photo" id="upload-photo" (change)="setInstanceFileStorage($event)" />
            </div>-->
          <span class="field__card--value text__color" style="font-size: 17px;"
            [ngClass]="{'color--error': !driver.state || (utils.isDefined(driver.state.active) && !driver.state.active), 'color--success': driver.state && driver.state.active}">
            {{adminUserService.getUserState(driver)}}
          </span>
        </div>
      </div>
    </div>
    <div class="container-info">
      <div class="info-first-column">
        <div>
          <span class="field__card--title">
            {{driver && driver.information && driver.information.name ? (driver.information.name | capitalizeText):
            cargo && cargo.driver ? cargo.driver : '-'}}
          </span>
          <p class="field__card--label">
            Conductor
          </p>
        </div>
        <div class="icons-container">
          <i class="fa fa-exclamation-circle font-secondary-dark i-view-error color--error" aria-hidden="true"
            *ngIf="driver && utils.isDefined(driver.state) && driver.state.description === 'Inactive'"></i>
          <i class="fas fa-eye font-secondary-dark i-view-info" (click)="openDetailDriver(driver)"></i>
          <i class="fas fa-exchange-alt font-secondary-dark i-view-info" (click)="changeDriver()" permission-display
            [module]="permission.administration.module" [functionality]="permission.administration.changeDriverVehicle"
            *ngIf="driver && utils.isDefined(driver.state) && driver.state.description !== 'Pending'"></i>
        </div>
      </div>
      <div class="separator_center"></div>
      <div class="container-text">
        <label class="field__card--label">
          Tipo de identificación
        </label>
        <label class="field__card--value">
          {{driver && driver.information && driver.information.documentTypeName ? driver.information.documentTypeName :
          '-'}}
        </label>
      </div>
      <div class="container-text">
        <label class="field__card--label">
          N° identificación
        </label>
        <label class="field__card--value">
          {{driver && driver.information && driver.information.document ? driver.information.document : '-'}}
        </label>
      </div>
      <div class="container-text">
        <label class="field__card--label">
          Celular
        </label>
        <label class="field__card--value">
          {{driver && driver.phone ? (driver.phone | phoneNumber): '-'}}
        </label>
      </div>
      <div class="container-text" *ngIf="driver && driver.city">
        <label class="field__card--label">
          Ciudad
        </label>
        <label class="field__card--value">
          {{driver.city}}
        </label>
      </div>
      <div class="container-text" *ngIf="driver && driver.address">
        <label class="field__card--label">
          Dirección
        </label>
        <label class="field__card--value">
          {{driver.address}}
        </label>
      </div>
      <div class="container-text" *ngIf="driver && driver.manifestQuantity
      ">
        <label class="field__card--label">
          N° de manifiestos
        </label>
        <label class="field__card--value">
          {{ driver.manifestQuantity }}
        </label>
        <div class="d-flex flex-column">
          <p class="show-more" (click)="openManifests()">Ver manifiestos</p>
        </div>
      </div>
      <div class="container-text" *ngIf="driver && !driver.manifestQuantity">
        <label class="field__card--label">
          Ver manifiestos:
        </label>
        <label class="field__card--value">
          {{ driver && driver.manifests && driver.manifests[0] ? driver.manifests[0].ministryId : '-' }}
        </label>
      </div>
    </div>
  </div>

  <!-- Owner -->
  <div class="container-owner" *ngIf="owner">
    <span class="field__card--title">
      {{owner && owner.information && owner.information.name ?
      (owner.information.name | capitalizeText):
      '-'}}
    </span>
    <p class="field__card--label">
      Propietario
    </p>
    <div class="separator_center"></div>
    <div class="container-text">
      <label class="field__card--label">
        Tipo de identificación
      </label>
      <label class="field__card--value">
        {{owner?.information?.documentTypeName}}
      </label>
    </div>
    <div class="container-text">
      <label class="field__card--label">
        N° identificación
      </label>
      <label class="field__card--value">
        {{owner?.information?.document}}
      </label>
    </div>
    <div class="container-text" *ngIf="owner?.address">
      <label class="field__card--label">
        Dirección
      </label>
      <label class="field__card--value">
        {{owner.address}}
      </label>
    </div>
  </div>
</div>

<!-- Admin -->
<div class="container-owner" *ngIf="administrator">
  <span class="field__card--title">
    {{administrator && administrator.name ? (administrator.name | capitalizeText):
    administrator.name}}
  </span>
  <p class="field__card--label">
    Administrador
  </p>
  <div class="separator_center"></div>
  <div class="container-text">
    <label class="field__card--label">
      Tipo de identificación
    </label>
    <label class="field__card--value">
      {{administrator.documentTypeName}}
    </label>
  </div>
  <div class="container-text">
    <label class="field__card--label">
      N° identificación
    </label>
    <label class="field__card--value">
      {{administrator.document}}
    </label>
  </div>
</div>